import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export enum BadgeVariant {
  TEXT = 'TEXT',
  ICON_ONLY = 'ICON_ONLY',
}

export enum BadgeEmphasis {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
}

export const BadgeColor = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info',
  NEUTRAL: 'neutral',
} as const;

export type BadgeColorType = (typeof BadgeColor)[keyof typeof BadgeColor];

export type BadgeProps = {
  color: BadgeColorType;
  variant?: BadgeVariant;
  /**
   * Visual emphasis of the `TEXT` variant: `PRIMARY` is a solid fill, `SECONDARY`
   * is a stroke only. Ignored for `ICON_ONLY`.
   */
  emphasis?: BadgeEmphasis;
  /**
   * Required when variant is TEXT (default). Ignored for ICON_ONLY.
   * Typed as optional because Vue cannot enforce discriminated unions at runtime.
   */
  text?: string;
  /**
   * Renders a `FontIcon` with the given tundr-icons name. Used by the `ICON_ONLY`
   * variant; overridden by the `icon` slot when provided.
   */
  iconName?: TUNDR_ICONS;
  testId?: string;
};
